<script setup lang="ts">
import { RrSkeleton } from '@xjlv2/ui'

withDefaults(
  defineProps<{
    rows?: number
    variant?: 'lines' | 'table' | 'metrics' | 'button' | 'avatar'
    active?: boolean
    loading?: boolean
  }>(),
  {
    rows: 4,
    variant: 'lines',
    active: true,
    loading: true
  }
)
</script>

<template>
  <RrSkeleton
    :rows="rows"
    :variant="variant"
    :active="active"
    :loading="loading"
  >
    <slot />
  </RrSkeleton>
</template>
